module.exports = __webpack_public_path__ + "img/hdr_weak.aa417598.svg";